import _ from 'underscore';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import user from 'js/lib/user';

import { DeleteState, SearchState } from 'bundles/groups-common/constants/MemberConstants';

const MemberStore = createStore({
  storeName: 'MemberStore',

  initialize() {
    this.deleteMembersStatus = DeleteState.IDLE;
    this.reset();
  },

  getMemberByUserId(userId: $TSFixMe) {
    return this.members && this.members.find((member: $TSFixMe) => member.userId.toString() === userId);
  },

  getLookupInput() {
    return this.lookupInput;
  },

  getMembers() {
    // show superusers to superusers only
    return user.isSuperuser() ? this.members : this.getNonSuperuserMembers();
  },

  getNonSuperuserMembers() {
    // GroupMembership is not guaranteed to have an email. In such a case, we still display the user.
    // Additionally, Coursera test accounts should not be displayed to customers when verifying courses.
    // However, Courselenium users should be treated normally in order to mimic end-to-end integration testcases.
    return (
      this.members &&
      this.members.filter((member: $TSFixMe) => {
        return (
          !member.email || // display users with no email
          member.email.indexOf('courselenium') === 0 || // display courselenium test users
          member.email.indexOf('@coursera.org') === -1
        ); // hide coursera users
      })
    );
  },

  getTotalCount() {
    return this.totalCount;
  },

  getDeleteMembersStatus() {
    return this.deleteMembersStatus;
  },

  getNotFoundList() {
    return this.notFoundList;
  },

  getSearchStatus() {
    return this.searchStatus;
  },

  reset() {
    this.members = null;
    this.notFoundList = null;
    this.lookupInput = null;
    this.searchStatus = {
      state: SearchState.IDLE,
      items: null,
    };
  },
});

MemberStore.handlers = {
  LOOKUP_MEMBERS({ lookupInput }: $TSFixMe) {
    this.lookupInput = lookupInput;
    this.emitChange();
  },

  ADD_SINGLE_MEMBER({ member }: $TSFixMe) {
    this.members = (this.members || []).concat(member);
  },

  RECEIVED_MEMBERS({ members, totalCount }: $TSFixMe) {
    this.members = members;
    this.totalCount = totalCount || 0;
    this.emitChange();
  },

  DELETE_MEMBER({ memberId }: $TSFixMe) {
    // @ts-expect-error ts-migrate(7006): Parameter member implicitly has an any type
    this.members = _(this.members).reject((member) => member.userId === memberId);
    this.emitChange();
  },

  RECEIVED_NOT_FOUND_LIST({ notFoundList }: $TSFixMe) {
    this.notFoundList = notFoundList;
    this.emitChange();
  },

  MEMBERS_RESET() {
    this.reset();
    this.emitChange();
  },

  DELETE_MEMBERS_STARTED() {
    this.deleteMembersStatus = DeleteState.DELETING;
    this.emitChange();
  },

  DELETE_MEMBERS_FINISHED() {
    this.deleteMembersStatus = DeleteState.DELETED;
    this.emitChange();
  },

  DELETE_MEMBERS_FAILED() {
    this.deleteMembersStatus = DeleteState.FAILED;
    this.emitChange();
  },

  DELETE_MEMBERS_RESET() {
    this.deleteMembersStatus = DeleteState.IDLE;
    this.emitChange();
  },

  SEARCH_MEMBERS_STARTED() {
    this.searchStatus = {
      state: SearchState.SEARCHING,
    };
    this.emitChange();
  },

  SEARCH_MEMBERS_SUCCEEDED({ members }: $TSFixMe) {
    // normalize items for search
    const items = _(members).map((item) => {
      return _(item).extend({
        email: item.userData.definition.email,
        fullName: item.userData.definition.fullName,
      });
    });

    this.searchStatus = {
      state: SearchState.SUCCEEDED,
      items,
    };
    this.emitChange();
  },

  SEARCH_MEMBERS_FAILED() {
    this.searchStatus = {
      state: SearchState.SEARCHING,
    };
    this.emitChange();
  },

  SEARCH_MEMBERS_STATUS_RESET() {
    this.searchStatus = {
      state: SearchState.IDLE,
    };
    this.emitChange();
  },
};

export default MemberStore;
